import {
    Box,
    Breadcrumbs, Divider, Grid, Link, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Paper, Typography
} from "@mui/material";
import React, {useMemo} from "react";
import PropTypes from "prop-types";
import FolderIcon from "@mui/icons-material/Folder";
import PersonIcon from "@mui/icons-material/Person";
import {Link as RouterLink, useLocation} from "react-router-dom";
import {useTranslation} from "react-i18next";

function AdminBreadcrumbs() {
    const {t} = useTranslation("common");
    const location = useLocation();
    const pathnames = location.pathname.split('/').filter((x) => x);

    const names = useMemo(() => {
        return {
            '/admin': t('main.pages.admin.routes.admin'),
            '/admin/users': t('main.pages.admin.users.title'),
            '/admin/collections': t('main.pages.admin.collections.title'),
        }
    }, [t, location]);

    return (<Breadcrumbs>
        {pathnames.map((value, index) => {
            const last = index === pathnames.length - 1;
            const to = `/${pathnames.slice(0, index + 1).join('/')}`;
            return last ? (<Typography color="text.primary" key={to}>
                {names[to] ?? value}
            </Typography>) : (<Link component={RouterLink} underline="hover" color="inherit" to={to} key={to}>
                {names[to] ?? value}
            </Link>);
        })}
    </Breadcrumbs>)
}

export default function AdminLayout(props) {
    const {t} = useTranslation("common");
    return (
        <Box display="flex" flexGrow={1} flexDirection="column" width="100%" p={2}>
            <Paper elevation={0} sx={{p: 1, mb: 1}}>
                <AdminBreadcrumbs/>
            </Paper>
            <Grid container spacing={1} rowSpacing={1} flex={1} alignItems="stretch">
                <Grid item xs={2}>
                    <Paper elevation={0} sx={{flexGrow: 1, p: 1, height: "100%"}}>
                        <List>
                            <ListItem>
                                <ListItemText>
                                    <Typography variant="h6" fontSize={22} fontWeight="bold" color="textSecondary">
                                        {t('main.pages.admin.title')}
                                    </Typography>
                                </ListItemText>
                            </ListItem>
                            <Divider />
                            <ListItem disablePadding>
                                <ListItemButton component={RouterLink} to="/admin/users">
                                    <ListItemIcon>
                                        <PersonIcon/>
                                    </ListItemIcon>
                                    <ListItemText>
                                        {t('main.pages.admin.users.title')}
                                    </ListItemText>
                                </ListItemButton>
                            </ListItem>
                            <ListItem disablePadding>
                                <ListItemButton component={RouterLink} to="/admin/collections">
                                    <ListItemIcon>
                                        <FolderIcon/>
                                    </ListItemIcon>
                                    <ListItemText>
                                        {t('main.pages.admin.collections.title')}
                                    </ListItemText>
                                </ListItemButton>
                            </ListItem>
                        </List>
                    </Paper>
                </Grid>
                <Grid item xs={10} sx={{display: "flex", flexDirection: "column"}}>
                    <Paper elevation={0} sx={{height: "100%", p: 1}}>
                        {props.children}
                    </Paper>
                </Grid>
            </Grid>
        </Box>
    );
}

AdminLayout.propTypes = {
    children: PropTypes.element.isRequired,
}